function matches(status, data, expectedStatus, id) {
    return status === expectedStatus && data?.errors?.some((entry) => entry.id === id) === true;
}
/**
 * True when `error` is an HTTP error carrying the given status and an `errors[].id` entry.
 * Handles both Axios (`error.response.{status,data}`) and Angular $http (`error.{status,data}`) shapes.
 */
export function isHttpErrorWithId(error, status, id) {
    if (typeof error !== 'object' || error === null)
        return false;
    const httpError = error;
    // Axios-style: error.response.{status,data}
    if (matches(httpError.response?.status, httpError.response?.data, status, id))
        return true;
    // Angular $http-style: error.{status,data}
    return matches(httpError.status, httpError.data, status, id);
}
